// ============ Demo File ============

export async function getDemoFile(fileName: string = 'demo.musicxml'): Promise<File> {
    const response = await fetch('/static/assets/' + fileName);

    if (!response.ok) {
        throw new Error(
            `Demo-Datei konnte nicht geladen werden (Status ${response.status}).`
        );
    }

    const blob = await response.blob();
    return new File([blob], fileName, {
        type: blob.type || 'application/vnd.recordare.musicxml+xml',
    });
}